/* eslint-disable react/jsx-no-target-blank */
import { FC } from 'react';
import styles from './TermsOfUseForm.module.less';
import { Breadcrumb } from 'components/Breadcrumb';
import { Trans } from 'next-i18next';
import { useTypeSafeTranslation } from 'hooks';

const TermsOfUseForm: FC = () => {
  const { t } = useTypeSafeTranslation();
  return (
    <div className={styles.container}>
      <Breadcrumb
        className={styles.breadcrumb}
        items={[
          { content: t('terms.legal_terms') },
          {
            content: t('terms.terms_of_use'),
          },
        ]}
      />
      <div className={styles.header}>
        <h1 className={styles.title}>
          <Trans i18nKey="terms.terms_of_use" />
        </h1>
        <i className="text-14">({t('privacy.revised')} 12/24/2021)</i>
      </div>
      <div className={styles.content}>
        <div className={styles.level2}>
          <Trans i18nKey="terms.parties_and_scope" />
        </div>
        <div>
          <Trans i18nKey="terms.parties_and_scope_1" />
        </div>
        <div>
          <Trans i18nKey="terms.parties_and_scope_2" />
        </div>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_1" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_1_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_1_2" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_2" />
        </div>
        <div>
          <div>
            <Trans i18nKey="terms.article_2_text" />
          </div>
          <ol className={styles.counterList}>
            <li>
              <Trans i18nKey="terms.article_2_1" />
            </li>
            <li>
              <Trans i18nKey="terms.article_2_2" />
            </li>
            <li>
              <Trans i18nKey="terms.article_2_3" />
            </li>
            <li>
              <Trans i18nKey="terms.article_2_4" />
            </li>
            <li>
              <Trans i18nKey="terms.article_2_5" />
            </li>
            <li>
              <Trans i18nKey="terms.article_2_6" />
            </li>
            <li>
              <Trans i18nKey="terms.article_2_7" />
            </li>
          </ol>
        </div>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_3" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_3_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_3_2" />
            <div>
              <Trans i18nKey="terms.article_3_2_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_3_2_2" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_3_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_3_4" />
          </li>
          <li>
            <Trans i18nKey="terms.article_3_5" />
            <div>
              <Trans i18nKey="terms.article_3_5_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_3_5_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_3_5_3" />
            </div>
            <div>
              <Trans i18nKey="terms.article_3_5_4" />
            </div>
            <div>
              <Trans i18nKey="terms.article_3_5_5" />
            </div>
            <div>
              <Trans i18nKey="terms.article_3_5_6" />
            </div>
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_4" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_4_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_4_2" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_5" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_5_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_5_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_5_3" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_6" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_6_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_6_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_6_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_6_4" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_7" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_7_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_7_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_7_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_7_4" />
            <div>
              <Trans i18nKey="terms.article_7_4_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_4_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_4_3" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_7_5" />
            <div>
              <Trans i18nKey="terms.article_7_5_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_5_2" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_7_6" />
            <div>
              <Trans i18nKey="terms.article_7_6_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_6_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_6_3" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_7_7" />
          </li>
          <li>
            <Trans i18nKey="terms.article_7_8" />
          </li>
          <li>
            <Trans i18nKey="terms.article_7_9" />
            <div>
              <Trans i18nKey="terms.article_7_9_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_9_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_9_3" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_9_4" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_9_5" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_9_6" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_9_7" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_9_8" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_7_10" />
            <div>
              <Trans i18nKey="terms.article_7_10_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_10_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_10_3" />
            </div>
            <div>
              <Trans i18nKey="terms.article_7_10_4" />
            </div>
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_8" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_8_1" />
            <div>
              <Trans i18nKey="terms.article_8_1_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_3" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_4" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_5" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_6" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_7" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_8" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_9" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_10" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_11" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_12" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_13" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_14" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_15" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_16" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_17" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_18" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_19" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_20" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_21" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_22" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_23" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_24" />
            </div>
            <div>
              <Trans i18nKey="terms.article_8_1_25" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_8_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_8_3" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_9" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_9_1" />
            <div>
              <Trans i18nKey="terms.article_9_1_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_3" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_4" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_5" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_6" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_7" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_8" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_9" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_10" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_11" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_12" />
            </div>
            <div>
              <Trans i18nKey="terms.article_9_1_13" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_9_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_9_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_9_4" />
          </li>
          <li>
            <Trans i18nKey="terms.article_9_5" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_10" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_10_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_10_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_10_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_10_4" />
          </li>
          <li>
            <Trans i18nKey="terms.article_10_5" />
          </li>
          <li>
            <Trans i18nKey="terms.article_10_6" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_11" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_11_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_11_2" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_12" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_12_1" />
            <div>
              <Trans i18nKey="terms.article_12_1_1" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_2" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_3" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_4" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_5" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_6" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_7" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_8" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_9" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_10" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_11" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_12" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_13" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_14" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_15" />
            </div>
            <div>
              <Trans i18nKey="terms.article_12_1_16" />
            </div>
          </li>
          <li>
            <Trans i18nKey="terms.article_12_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_12_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_12_4" />
          </li>
          <li>
            <Trans i18nKey="terms.article_12_5" />
          </li>
          <li>
            <Trans i18nKey="terms.article_12_6" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_13" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_13_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_4" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_5" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_6" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_7" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_8" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_9" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_10" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_11" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_12" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_13" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_14" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_15" />
          </li>
          <li>
            <Trans i18nKey="terms.article_13_16" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_14" />
        </div>
        <div>
          <Trans i18nKey="terms.article_14_text" />
        </div>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_15" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_15_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_15_2" />
          </li>
          <li>
            <Trans i18nKey="terms.article_15_3" />
          </li>
          <li>
            <Trans i18nKey="terms.article_15_4" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_16" />
        </div>
        <div>
          <Trans i18nKey="terms.article_16_text" />
        </div>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_17" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_17_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_17_2" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_18" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_18_1" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_19" />
        </div>
        <ol className={styles.counterList}>
          <li>
            <Trans i18nKey="terms.article_19_1" />
          </li>
          <li>
            <Trans i18nKey="terms.article_19_2" />
          </li>
        </ol>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_20" />
        </div>
        <div>
          <Trans i18nKey="terms.article_20_text" />
        </div>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_21" />
        </div>
        <div>
          <Trans i18nKey="terms.article_21_text" />
        </div>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_22" />
        </div>
        <div>
          <Trans i18nKey="terms.article_22_text" />
        </div>

        <div className={styles.level2}>
          <Trans i18nKey="terms.article_23" />
        </div>
        <ol className={styles.counterList}>
          <li>
            {' '}
            <Trans i18nKey="terms.article_23_1" />
          </li>
          <li>
            {' '}
            <Trans i18nKey="terms.article_23_2" />
          </li>
        </ol>
      </div>
    </div>
  );
};

export default TermsOfUseForm;
